<template>
  <div>
    <v-form
      :disabled="form.processing"
      @submit.prevent="submit"
    >
      <v-text-field
        v-model="form.name"
        :loading="form.processing"
        :error-messages="form.errors.name"
        :label="$t('Name')"
        outlined
      />

      <v-textarea
        v-model="form.description"
        :loading="form.processing"
        :error-messages="form.errors.description"
        :label="$t('Description')"
        :rows="3"
        outlined
      />


      <div class="mb-6 grey--text text--darken-4">
        <p class="font-weight-bold mb-0">
          {{ $t('Default language') }}:
        </p>
        {{ faq.all_languages[faq.default_language].formatted }}
      </div>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('Labels and texts') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="mb-3">
                  <p class="mb-0 subtitle-2">
                    {{ $t('Search placeholder text') }}
                  </p>
                </div>

                <v-text-field
                  v-model="form.search_placeholder"
                  dense
                  class="mb-3"
                  hide-details
                  outlined
                  :placeholder="defaultStrings.search_placeholder"
                />

                <div class="mb-3">
                  <p class="mb-0 subtitle-2">
                    {{ $t('Search results text') }}
                  </p>
                </div>

                <v-text-field
                  v-model="form.search_results"
                  dense
                  class="mb-3"
                  hide-details
                  outlined
                  :placeholder="defaultStrings.search_results"
                />

                <div class="mb-3">
                  <p class="mb-0 subtitle-2">
                    {{ $t('User feedback saved text') }}
                  </p>
                </div>

                <v-text-field
                  v-model="form.user_feedback_saved"
                  dense
                  class="mb-3"
                  hide-details
                  outlined
                  :placeholder="defaultStrings.user_feedback_saved"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <div class="mb-3">
                  <p class="mb-0 subtitle-2">
                    {{ $t('No search results text') }}
                  </p>
                </div>

                <v-text-field
                  v-model="form.no_search_results"
                  dense
                  class="mb-3"
                  hide-details
                  outlined
                  :placeholder="defaultStrings.no_search_results"
                />

                <div class="mb-3">
                  <p class="mb-0 subtitle-2">
                    {{ $t('User feedback text') }}
                  </p>
                </div>

                <v-text-field
                  v-model="form.user_feedback"
                  dense
                  class="mb-3"
                  hide-details
                  outlined
                  :placeholder="defaultStrings.user_feedback"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('Contact information') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-textarea
              v-model="form.contact_description"
              :error-messages="form.errors.contact_description"
              :label="$t('Description')"
              :counter="500"
              outlined
              :rows="3"
            />
            <v-row>
              <v-col
                cols="12"
                sm="4"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.contact_email"
                  :error-messages="form.errors.contact_email"
                  dense
                  outlined
                  :label="$t('Email')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.contact_phone"
                  :error-messages="form.errors.contact_phone"
                  dense
                  outlined
                  :label="$t('Phone')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.contact_url"
                  :error-messages="form.errors.contact_url"
                  dense
                  outlined
                  :label="$t('Link to your website')"
                />

                <v-text-field
                  v-model="form.contact_url_text"
                  :error-messages="form.errors.contact_url_text"
                  dense
                  outlined
                  :label="$t('Link text')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="form.contact_primary"
                  :error-messages="form.errors.contact_primary"
                  :items="contactPrimaryMethods"
                  :label="$t('Primary contact method')"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('Contact form') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    v-model="form.contact_form_heading"
                    :disabled="form.processing"
                    :loading="form.processing"
                    :error-messages="form.errors.contact_form_heading"
                    hide-details="auto"
                    :label="$t('Heading')"
                    outlined
                    dense
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-textarea
                    v-model="form.contact_form_description"
                    :maxlength="255"
                    :counter="true"
                    :rows="2"
                    :disabled="form.processing"
                    :loading="form.processing"
                    :error-messages="form.errors.contact_form_description"
                    hide-details="auto"
                    :label="$t('Description')"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
              <contact-form-fields-manage
                :faq-id="faq.id"
                :fields="faq.contact_form_fields"
                :field-types="contactFormFieldTypes"
                class="mb-6 mt-6"
              />
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="form.contact_form_submit"
                    :disabled="form.processing"
                    :loading="form.processing"
                    :error-messages="form.errors.contact_form_submit"
                    hide-details="auto"
                    :label="$t('Submit button text')"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-textarea
                    v-model="form.contact_form_success_message"
                    :rows="3"
                    :disabled="form.processing"
                    :loading="form.processing"
                    :error-messages="form.errors.contact_form_success_message"
                    :label="$t('Confirmation message')"
                    outlined
                    dense
                    :hint="$t('Enter a message that will be displayed when the contact form has been sent')"
                    persistent-hint
                  />
                </v-col>
              </v-row>
            </div>

            <v-expansion-panels
              accordion
              class="mt-6"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('Custom JavaScript') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <code-editor
                    v-model="form.contact_form_js"
                    language="javascript"
                    style="min-height: 300px"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-divider class="mt-6 mb-4" />

            <p class="text-h6 mt-0 mb-6">
              {{ $t('Email settings') }}
            </p>

            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="form.contact_form_email_logo_upload_id"
                  :loading="form.processing"
                  :error-messages="form.errors.contact_form_email_logo_upload_id"
                  class="mb-2"
                  :items="images"
                  :label="$t('Choose logotype')"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                  clearable
                  :hint="$t('Choose an image from your media library to use as logo (recommended size is 200x55px)')"
                  persistent-hint
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="form.contact_form_user_email_field"
                  :loading="form.processing"
                  :error-messages="form.errors.contact_form_user_email_field"
                  class="mb-2"
                  :items="replyToFieldCandidates"
                  :label="$t('Reply-To field')"
                  item-text="default_translation.label"
                  item-value="id"
                  outlined
                  dense
                  clearable
                  :hint="$t(`Select the field containing the user's email address (if applicable). The field must be of type 'email' and required.`)"
                  persistent-hint
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="form.contact_form_email_subject"
                  :disabled="form.processing"
                  :loading="form.processing"
                  :error-messages="form.errors.contact_form_email_subject"
                  :label="$t('Subject')"
                  outlined
                  dense
                  persistent-placeholder
                  :placeholder="faq.default_translation.name"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="form.contact_form_email"
                  :disabled="form.processing"
                  :loading="form.processing"
                  :error-messages="form.errors.contact_form_email"
                  :label="$t('Recipient e-mail')"
                  outlined
                  dense
                  :hint="$t('Enter the e-mail address that the contact form details should be delivered to')"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <open-ai-expansion-panel
          :no-wrapping-panels="true"
        >
          <v-text-field
            v-model="form.openai_description"
            :loading="form.processing"
            :error-messages="form.errors['open_ai.category']"
            :label="$t(`OpenAI description`)"
            :placeholder="$t('E.g. online store for kids toys')"
            :hint="$t('This description will be used as context when generating data using OpenAI')"
            class="mt-2 mb-2"
            persistent-hint
            :maxlength="50"
            :counter="true"
            hide-details="auto"
            outlined
          />
        </open-ai-expansion-panel>
      </v-expansion-panels>

      <portal to="faq-settings-layout-submit">
        <v-btn
          type="submit"
          color="primary"
          :loading="form.processing"
          :disabled="form.processing"
          @click="submit"
        >
          {{ $t('Save changes') }}
        </v-btn>
      </portal>
    </v-form>

    <div>
      <v-divider class="mt-8 mb-6" />

      <div class="text-right">
        <v-btn
          outlined
          color="primary"
          @click="cloneDialog = true"
        >
          {{ $t('Duplicate FAQ') }}
        </v-btn>

        <v-btn
          v-if="permissions.canDeleteFaq"
          class="ml-4"
          outlined
          color="error"
          @click="deleteFaq"
        >
          {{ $t('Remove FAQ') }}
        </v-btn>
      </div>
    </div>

    <clone-dialog
      v-model="cloneDialog"
      :faq="faq"
    />
  </div>
</template>

<script>
import ContactFormFieldsManage from '@/components/faq/ContactFormFieldsManage';
import CloneDialog from '@/components/faq/CloneDialog';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';
import SettingsLayout from '@/components/faq/settings/TabsLayout';
import unsavedFormWarningMixin from '@/mixins/faq/unsaved-form-warning';
import OpenAiExpansionPanel from '@/components/shared/OpenAiExpansionPanel';

export default {
  components: {
    ContactFormFieldsManage,
    OpenAiExpansionPanel,
    CloneDialog
  },

  mixins: [ unsavedFormWarningMixin ],

  layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'settings',
      faq: page.data.props.faq,
    }
  }, [h(SettingsLayout, {
      props: {
        faq: page.data.props.faq,
        activeTab: 'general'
      }
    }, [page])
  ])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    permissions: {
      type: Object,
      required: true
    },
    defaultStrings: {
      type: Object,
      required: true
    },
    contactFormFieldTypes: {
      type: Array,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        name: this.faq.default_translation.name,
        description: this.faq.default_translation.description,
        search_placeholder: this.faq.default_translation.search_placeholder,
        search_results: this.faq.default_translation.search_results,
        no_search_results: this.faq.default_translation.no_search_results,
        user_feedback: this.faq.default_translation.user_feedback,
        user_feedback_saved: this.faq.default_translation.user_feedback_saved,
        contact_primary: this.faq.contact_primary,
        contact_description: this.faq.default_translation.contact_description,
        contact_url_text: this.faq.default_translation.contact_url_text,
        contact_email: this.faq.contact_email,
        contact_phone: this.faq.contact_phone,
        contact_url: this.faq.contact_url,
        contact_form_email: this.faq.contact_form_email,
        contact_form_email_subject: this.faq.default_translation.contact_form_email_subject,
        contact_form_email_logo_upload_id: this.faq.contact_form_email_logo_upload_id,
        contact_form_submit: this.faq.default_translation.contact_form_submit,
        contact_form_success_message: this.faq.default_translation.contact_form_success_message,
        contact_form_heading: this.faq.default_translation.contact_form_heading,
        contact_form_description: this.faq.default_translation.contact_form_description,
        contact_form_js: this.faq.contact_form_js,
        contact_form_user_email_field: this.faq.contact_form_user_email_field,
        openai_description: this.faq.openai_description,
      }),

      cloneDialog: false
    }
  },

  computed: {
    contactPrimaryMethods() {
      return [
        { text: '', value: null },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Phone'), value: 'phone' },
        { text: this.$t('Website'), value: 'url' },
      ];
    },

    replyToFieldCandidates() {
      return this.faq.contact_form_fields.filter((field) => {
        return field.type === 'email' && field.required;
      });
    }
  },

  created() {
    window.onbeforeunload = () => this.form.isDirty ? '' : null;
  },

  methods: {
    submit() {
      const url = this.route('faq-settings.general.update', this.faq.id);
      this.form.patch(url.toString(), {
        onSuccess: () => {
          this.$root.refreshFaqPreview();
        }
      });
    },

    async deleteFaq() {
      // FIXME: add translation
      const confirmed = await this.$root.$confirm(
        this.$t('Remove FAQ'), this.$t('<p>Are you sure you want to continue?</p><p>The entire FAQ will be removed including categories and questions.</p>This action cannot be undone.')
      );

      if (confirmed) {
        const url = this.route('faq.destroy', { faq: this.faq.id });
        this.$inertia.delete(url);
      }
    },
  }
}
</script>